import type { NuxtApp } from '#app';
import { useAuthService } from '~/composables/services/useAuthService';
import { useComplianceService } from '~/composables/services/useComplianceService';
import { useConfigService } from '~/composables/services/useConfigService';
import { useContentService } from '~/composables/services/useContentService';
import { useFormService } from '~/composables/services/useFormService';
import { useGameService } from '~/composables/services/useGameService';
import { useJackpotService } from '~/composables/services/useJackpotService';
import { useLaunchService } from '~/composables/services/useLaunchService';
import { useLocaleService } from '~/composables/services/useLocaleService';
import { useMarketingService } from '~/composables/services/useMarketingService';
import { usePromotionService } from '~/composables/services/usePromotionService';
import { useSitemapService } from '~/composables/services/useSitemapService';
import { useStorageService } from '~/composables/services/useStorageService';
import { useWalletService } from '~/composables/services/useWalletService';
import { useWinnerService } from './services/useWinnerService';

export const useServices = (nuxtApp?: NuxtApp) => {
  return {
    $authService: useAuthService(),
    $complianceService: useComplianceService(),
    $configService: useConfigService(),
    $contentService: useContentService(),
    $formService: useFormService(),
    $gameService: useGameService(),
    $jackpotService: useJackpotService(),
    $launchService: useLaunchService(),
    $localeService: useLocaleService(nuxtApp),
    $marketingService: useMarketingService(),
    $promotionService: usePromotionService(),
    $sitemapService: useSitemapService(),
    $storageService: useStorageService(),
    $walletService: useWalletService(),
    $winnerService: useWinnerService(),
  };
};
